// Sticky header scroll class
(function () {
  var header = document.getElementById('site-header');
  if (!header) return;
  var onScroll = function () {
    header.classList.toggle('scrolled', window.scrollY > 10);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// Header: categories dropdown (keyboard + click)
(function () {
  var btn = document.querySelector('.header-dropdown-btn');
  var dropdown = document.querySelector('.header-dropdown');
  if (!btn || !dropdown) return;

  function open() { btn.setAttribute('aria-expanded', 'true'); }
  function close() { btn.setAttribute('aria-expanded', 'false'); }

  btn.addEventListener('click', function () {
    btn.getAttribute('aria-expanded') === 'true' ? close() : open();
  });
  document.addEventListener('click', function (e) {
    if (!btn.closest('.header-dropdown-wrap').contains(e.target)) close();
  });
  btn.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

// Header: language dropdown
(function () {
  var langBtn = document.querySelector('.header-lang-btn');
  if (!langBtn) return;
  var langDropdown = langBtn.nextElementSibling;
  if (!langDropdown) return;

  langBtn.addEventListener('click', function () {
    var expanded = langBtn.getAttribute('aria-expanded') === 'true';
    langBtn.setAttribute('aria-expanded', String(!expanded));
    if (expanded) { langDropdown.hidden = true; } else { langDropdown.hidden = false; }
  });
  document.addEventListener('click', function (e) {
    if (!langBtn.closest('.header-lang-wrap').contains(e.target)) {
      langBtn.setAttribute('aria-expanded', 'false');
      langDropdown.hidden = true;
    }
  });
})();

// Header: mobile drawer toggle
(function () {
  var toggle = document.getElementById('header-menu-toggle');
  var drawer = document.getElementById('header-mobile-drawer');
  if (!toggle || !drawer) return;
  var hamburger = toggle.querySelector('.icon-hamburger');
  var closeIcon = toggle.querySelector('.icon-close');

  toggle.addEventListener('click', function () {
    var isOpen = !drawer.hidden;
    drawer.hidden = isOpen;
    toggle.setAttribute('aria-expanded', String(!isOpen));
    if (hamburger) hamburger.style.display = isOpen ? '' : 'none';
    if (closeIcon) closeIcon.style.display = isOpen ? 'none' : '';
  });
})();

// Scroll reveal
(function () {
  var elements = document.querySelectorAll('.reveal');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  elements.forEach(function (el) { observer.observe(el); });
})();

// FAQ accordion
(function () {
  var items = document.querySelectorAll('.faq-item');
  items.forEach(function (item) {
    var btn = item.querySelector('.faq-question');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      items.forEach(function (i) {
        i.classList.remove('open');
        var b = i.querySelector('.faq-question');
        var a = i.querySelector('.faq-answer');
        if (b) b.setAttribute('aria-expanded', 'false');
        if (a) a.hidden = true;
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        var answer = item.querySelector('.faq-answer');
        if (answer) answer.hidden = false;
      }
    });
  });
})();

// Newsletter signup
function handleSignup(e) {
  e.preventDefault();
  var emailInput = document.getElementById('signup-email');
  var nameInput = document.getElementById('signup-name');
  var btn = e.target.querySelector('button[type="submit"]');
  var orig = btn.textContent;
  btn.textContent = '✓ Welcome to the Alley!';
  btn.style.background = 'linear-gradient(135deg, #1abc9c, #16a085)';
  btn.disabled = true;
  if (emailInput) emailInput.value = '';
  if (nameInput) nameInput.value = '';
  setTimeout(function () {
    btn.textContent = orig;
    btn.style.background = '';
    btn.disabled = false;
  }, 4000);
}

// JSON-LD structured data
(function () {
  var schema = {
    "@context": "https://schema.org",
    "@type": "Store",
    "name": "Kamisama Alley",
    "description": "Premium anime collectibles, stickers, and trading cards curated by fans for fans.",
    "url": "https://kamisamaalley.com",
    "logo": "https://kamisamaalley.com/cdn/shop/files/Logo_K.A..jpg",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Anime Merchandise",
      "itemListElement": [
        { "@type": "OfferCatalog", "name": "Anime Stickers" },
        { "@type": "OfferCatalog", "name": "Anime Trading Cards" },
        { "@type": "OfferCatalog", "name": "Anime Collectibles" }
      ]
    }
  };
  var el = document.createElement('script');
  el.type = 'application/ld+json';
  el.textContent = JSON.stringify(schema);
  document.head.appendChild(el);
})();

// ===== HEADER SEARCH OVERLAY =====
(function () {
  var searchBtn   = document.getElementById('header-search-btn');
  var searchBar   = document.getElementById('header-search-bar');
  var searchClose = document.getElementById('header-search-close');
  var searchInput = document.getElementById('header-search-input');
  if (!searchBtn || !searchBar) return;

  function openSearch() {
    searchBar.classList.add('open');
    searchBar.removeAttribute('aria-hidden');
    searchBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
  }
  function closeSearch() {
    searchBar.classList.remove('open');
    searchBar.setAttribute('aria-hidden', 'true');
    searchBtn.setAttribute('aria-expanded', 'false');
    searchBtn.focus();
  }

  searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchBar.classList.contains('open')) closeSearch();
  });
})();

// ===== CART PAGE =====
(function () {
  if (!document.querySelector('.cart-section')) return;

  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateBadge(count) {
    var badge = document.querySelector('.header-cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? '' : 'none';
  }

  async function cartChange(key, qty) {
    try {
      var resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      return await resp.json();
    } catch (e) { return null; }
  }

  function updateUI(cart, key, qty) {
    var subtotalEl = document.getElementById('cart-subtotal');
    var totalEl    = document.getElementById('cart-total');
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);
    if (totalEl)    totalEl.textContent    = fmtMoney(cart.total_price);
    updateBadge(cart.item_count);

    var row = document.querySelector('.cart-item[data-key="' + key + '"]');
    if (!row) return;

    if (qty === 0) {
      row.remove();
      if (cart.item_count === 0) location.reload();
      return;
    }

    var qtyEl = row.querySelector('.cart-qty-val');
    if (qtyEl) qtyEl.textContent = qty;

    var lineItem = cart.items.find(function (i) { return i.key === key; });
    if (lineItem) {
      var lineEl = row.querySelector('.cart-item-total');
      if (lineEl) lineEl.textContent = fmtMoney(lineItem.line_price);
    }
  }

  document.addEventListener('click', async function (e) {
    var row = e.target.closest('.cart-item');
    if (!row) return;
    var key = row.dataset.key;

    var qtyEl = row.querySelector('.cart-qty-val');
    var current = qtyEl ? parseInt(qtyEl.textContent) : 1;
    var qty;

    if (e.target.closest('.cart-qty-minus')) qty = Math.max(0, current - 1);
    else if (e.target.closest('.cart-qty-plus')) qty = current + 1;
    else if (e.target.closest('.cart-item-remove')) qty = 0;
    else return;

    var btn = e.target.closest('button');
    if (btn) btn.disabled = true;
    var cart = await cartChange(key, qty);
    if (cart) updateUI(cart, key, qty);
    if (btn) btn.disabled = false;
  });
})();

// ===== AUTH PANELS (login/register/forgot) =====
(function () {
  var panels = {
    login:    document.getElementById('login-panel'),
    register: document.getElementById('register-panel'),
    forgot:   document.getElementById('forgot-panel')
  };
  if (!panels.login) return;

  function showPanel(name) {
    Object.keys(panels).forEach(function (k) {
      if (panels[k]) panels[k].style.display = k === name ? '' : 'none';
    });
  }

  var showReg    = document.getElementById('show-register');
  var showLog    = document.getElementById('show-login');
  var showForgot = document.getElementById('show-forgot');
  var backLogin  = document.getElementById('back-to-login');

  if (showReg)    showReg.addEventListener('click',    function () { showPanel('register'); });
  if (showLog)    showLog.addEventListener('click',    function () { showPanel('login'); });
  if (showForgot) showForgot.addEventListener('click', function () { showPanel('forgot'); });
  if (backLogin)  backLogin.addEventListener('click',  function () { showPanel('login'); });
})();

// ===== PRODUCT PAGE =====
(function () {
  if (!document.getElementById('product-form')) return;

  // ----- Thumbnail gallery -----
  var thumbs = document.querySelectorAll('.product-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('main-product-img');
      if (mainImg) {
        mainImg.src = this.dataset.imgSrc;
        mainImg.alt = this.dataset.imgAlt;
      }
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ----- Quantity +/- -----
  var qtyInput = document.getElementById('product-qty-input');
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus  = document.querySelector('.qty-plus');
  if (qtyInput) {
    if (qtyMinus) qtyMinus.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1); });
    if (qtyPlus)  qtyPlus.addEventListener('click',  function () { qtyInput.value = Math.min(99, parseInt(qtyInput.value) + 1); });
  }

  // ----- Description accordion -----
  var descToggle = document.querySelector('.product-desc-toggle');
  var descBody   = document.querySelector('.product-desc-body');
  if (descToggle && descBody) {
    descToggle.addEventListener('click', function () {
      var isOpen = descBody.classList.toggle('open');
      this.setAttribute('aria-expanded', String(isOpen));
      var arrow = this.querySelector('.desc-arrow');
      if (arrow) arrow.style.transform = isOpen ? 'rotate(180deg)' : '';
    });
  }

  // ----- Variant selection -----
  var variants = window.__productData && window.__productData.variants;
  var optionBtns = document.querySelectorAll('.product-option-btn');
  if (variants && optionBtns.length) {
    var selectedOptions = [];
    document.querySelectorAll('.product-option').forEach(function (optEl, idx) {
      var active = optEl.querySelector('.product-option-btn.active');
      selectedOptions[idx] = active ? active.dataset.value : '';
    });

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(this.dataset.optionPos) - 1;
        var val = this.dataset.value;
        selectedOptions[pos] = val;

        // Update active state
        document.querySelectorAll('.product-option-btn[data-option-pos="' + this.dataset.optionPos + '"]').forEach(function (b) {
          b.classList.toggle('active', b.dataset.value === val);
        });
        var label = this.closest('.product-option').querySelector('.option-selected-val');
        if (label) label.textContent = val;

        // Find matching variant
        var matched = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selectedOptions[i]; });
        });
        if (!matched) return;

        // Update variant ID
        var vid = document.getElementById('product-variant-id');
        if (vid) vid.value = matched.id;

        // Update price
        var priceEl = document.getElementById('product-price-display');
        if (priceEl) {
          var fmt = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); };
          if (matched.compare_at_price && matched.compare_at_price > matched.price) {
            priceEl.innerHTML = '<span class="product-price-sale">' + fmt(matched.price) + '</span>' +
              '<span class="product-price-was">' + fmt(matched.compare_at_price) + '</span>' +
              '<span class="product-price-save">Save ' + fmt(matched.compare_at_price - matched.price) + '</span>';
          } else {
            priceEl.innerHTML = '<span class="product-price-main">' + fmt(matched.price) + '</span>';
          }
        }

        // Update availability
        var atcEl = document.getElementById('atc-section');
        var oosEl = document.getElementById('oos-section');
        if (atcEl) atcEl.style.display = matched.available ? '' : 'none';
        if (oosEl) oosEl.style.display = matched.available ? 'none' : '';
      });
    });
  }

  // ----- Product recommendations (Shopify API) -----
  var recSection = document.getElementById('product-recommendations');
  if (recSection) {
    var pid = recSection.dataset.productId;
    var sid = recSection.dataset.sectionId;
    if (pid && sid) {
      fetch('/recommendations/products?product_id=' + pid + '&section_id=' + sid + '&limit=4')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newContent = doc.getElementById('product-recommendations');
          if (newContent && newContent.innerHTML.trim()) {
            recSection.innerHTML = newContent.innerHTML;
            recSection.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
          }
        })
        .catch(function () {});
    }
  }
})();
